<template>
    <v-dialog
        v-model="isShowing"
        persistent
        :width="width">
        <v-card
            dark>
			<v-card-title>
				<template v-if="title">{{$t(`text.${title}`)}}</template>
			</v-card-title>
            <v-card-text>
				{{$t(`text.${text}`)}}<br>
				<pre>{{hardText}}</pre>
            </v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					v-if="isHint"
					color="primary"
					@click="onClick(1)">
					{{$t('text.ok')}}
				</v-btn>
				<template
						v-if="isConfirm">
					<v-btn
						color="primary"
						@click="onClick(1)">
						{{$t('text.yesButton')}}
					</v-btn>
					<v-btn
						color="primary"
						text
						@click="onClick(0)">
						{{$t('text.abort')}}
					</v-btn>

				</template>
          </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
	name: 'Spinner',
	props: {
		value: {
			type: Number,
			required: true,
		},
		type: {
			type: String,
			required: true,
		},
		show: {
			type: Boolean,
			required: true,
		},
		title: {
			type: String,
			default: 'dialog',
		},
		text: {
			type: String,
			required: true,
		},
		hardText: {
			type: String,
			required: false,
		},
		width: {
			type: String,
			required: false,
			default: '300px',
		},
		props: {
			type: Object,
			required: false,
		},
	},
	methods: {
		onClick(v) {
			this.iValue = v;
			this.isShowing = false;
			this.$emit('input', this.iValue);
			this.$emit('close', this.props);
			this.$emit('change', this.iValue, this.props);
		},
	},
	data() {
		return {
			isShowing: false,
			iValue: 0,
		};
	},
	watch: {
		show() {
			this.isShowing = this.show;
		},
		value() {
			this.iValue = this.value;
		},
	},
	mounted() {
		this.isShowing = this.show;
		this.iValue = this.value;
	},
	computed: {
		isHint() {
			return this.type === 'hint';
		},
		isConfirm() {
			return this.type === 'confirm';
		},
	},
};
</script>
